import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { FiRefreshCw, FiTrash2 } from 'react-icons/fi';
import './ConfirmDialog.css';

const ConfirmDialog = ({
    open,
    title = 'Are you sure?',
    message,
    confirmLabel = 'Delete',
    cancelLabel = 'Cancel',
    busyLabel,
    variant = 'danger',
    onConfirm,
    onCancel,
    busy = false,
}) => {
    useEffect(() => {
        if (!open) return undefined;
        const onKeyDown = (event) => {
            if (event.key === 'Escape' && !busy) onCancel?.();
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [open, busy, onCancel]);

    if (!open) return null;

    const isSuccess = variant === 'success';
    const Icon = isSuccess ? FiRefreshCw : FiTrash2;
    const defaultBusyLabel = isSuccess ? 'Relisting…' : 'Deleting…';

    return createPortal(
        <div className="msv-confirm-overlay" role="presentation" onClick={() => !busy && onCancel?.()}>
            <div
                className={`msv-confirm-dialog${isSuccess ? ' is-success' : ''}`}
                role="alertdialog"
                aria-modal="true"
                aria-labelledby="msv-confirm-title"
                aria-describedby="msv-confirm-message"
                onClick={(event) => event.stopPropagation()}
            >
                <div className={`msv-confirm-icon${isSuccess ? ' is-success' : ''}`} aria-hidden="true">
                    <Icon />
                </div>
                <h3 id="msv-confirm-title">{title}</h3>
                <p id="msv-confirm-message">{message}</p>
                <div className="msv-confirm-actions">
                    <button
                        type="button"
                        className="msv-confirm-cancel"
                        onClick={onCancel}
                        disabled={busy}
                    >
                        {cancelLabel}
                    </button>
                    <button
                        type="button"
                        className={isSuccess ? 'msv-confirm-success' : 'msv-confirm-danger'}
                        onClick={onConfirm}
                        disabled={busy}
                    >
                        {busy ? (busyLabel || defaultBusyLabel) : confirmLabel}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ConfirmDialog;
